/* eslint-disable no-shadow */
import React, { useState } from 'react';
import {
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  FormHelperText,
  CircularProgress,
  FormControlLabel,
  DialogContentText,
  Paper,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Autocomplete } from '@material-ui/lab';
import MultiSelect from 'src/components/sharedComponents/Multiselect/Multiselect';
/*import {
  isNitValid,
  isCodeValid,
  isPhoneValid,
  isEmailValid,
} from 'src/utils/inputValidations';*/
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import {
  useStyles, OrangeSwitch, OrangeCheckbox, OrangeTextField,
} from './styles';

const initialError = {
  nombre_campana: '',
  estado_global: '',
  estado: '',
  fechaInicial: '',
  fechaFinal: ''
};

const CampanasAdd = (props) => {
  const {
    form,
    isEdit,
    loading,
    onClose,
    controls,
    ciudades,
    vehiculos,
    establecimientos,
    handleSubmit,
    onChangeInputs,
    openAddToSocio,
    selectedDateInit,
    selectedDateEnd,
  } = props;

  const [inputsStates, setInputsStates] = useState({
    inputCiudades: '',
    inputVehiculos: '',
    inputEstablecimientos: '',
    inputFechaInicial: '',
    inputFechaFinal: ''
  });

  const [error, setError] = useState(initialError);
  const disabled =  error.nombre_campana !== ''
    || error.estado_global !== ''
    //|| error.fecha_inicio !== ''
   // || error.fecha_fin !== '';

  const classes = useStyles();
  const createTitle = 'Cree una campaña especifica seleccionando los establecimientos y vehículos que atenderán';
  const editTitle = 'Edite una campaña, los cambios que realice no se podrán recuperar';

  const onChangeinputValue = (newValue, field) => {
    setInputsStates({ ...inputsStates, [field]: newValue });
  };
  const filteredCiudades = ciudades.filter(
    (ciudad) => ciudad.NOMBRE_MPI.includes(
      inputsStates.inputCiudades.toLocaleUpperCase(),
    )
      || ciudad.NOMBRE_DPT.includes(
        inputsStates.inputCiudades.toLocaleUpperCase(),
      ),
  );

  const filteredVehiculos = vehiculos.filter((vehiculo) => vehiculo.linea.includes(
    inputsStates.inputVehiculos.toLocaleUpperCase()
  ));

  const filteredEstablecimientos = establecimientos.filter(
        (establecimiento) => establecimiento.nombre_establecimiento.includes(
            inputsStates.inputEstablecimientos.toLocaleUpperCase(),
          )
          || establecimiento.ciudad.includes(
            inputsStates.inputEstablecimientos.toLocaleUpperCase()
          )
  );


  return (
    <>
      <Dialog
        open={openAddToSocio}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Typography className={classes.mainTitle}>
          {isEdit ? 'Editar Campaña Especifica' : 'Agregar Campaña Especifica'}
        </Typography>
        <DialogContent>
          <DialogContentText>
            {isEdit ? editTitle : createTitle}
          </DialogContentText>
          <form action="/" onSubmit={handleSubmit}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <FormControlLabel
                label="Campaña Global"
                control={(
                  <OrangeSwitch
                    checked={controls.estadoGlobalControl}
                    onChange={(e) => {
                      const isActive = e.target.checked ? 1 : 0;
                      onChangeInputs(isActive, 'estado_global');
                    }}
                  />
                )}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <FormControlLabel
                label="Estado"
                control={(
                  <OrangeSwitch
                    checked={Boolean(Number(form.estado))}
                    onChange={(e) => {
                      const isActive = e.target.checked ? 1 : 0;
                      onChangeInputs(isActive, 'estado');
                    }}
                  />
                )}
              />
            </div>
            <div>
              <OrangeTextField
                fullWidth
                value={form.nombre_campana || ''}
                onChange={(event) => onChangeInputs(event.target.value, 'nombre_campana')}
                required
                id="nombre_campana"
                name="nombre_campana"
                label="Nombre Campaña"
              />
            </div>

            { (Number(form.estado_global) === 0) ? (
            <div>
              <MultiSelect
                originalArr={ciudades.map((ciudad) => ({
                  label: `${ciudad.NOMBRE_MPI} (${ciudad.NOMBRE_DPT})`,
                  value: ciudad.NOMBRE_MPI,
                  value2: ciudad.NOMBRE_DPT,
                }))}
                limitTags={4}
                items={filteredCiudades.map((ciudad) => ({
                  label: `${ciudad.NOMBRE_MPI} (${ciudad.NOMBRE_DPT})`,
                  value: ciudad.NOMBRE_MPI,
                  value2: ciudad.NOMBRE_DPT,
                }))}
                label="Ciudades que atiende"
                placeholder="Ciudades"
                selectAllLabel="Todos"
                initialValue={controls.ciudadControl}
                onChange={(e) => {
                  onChangeInputs(e, 'campanasCiudades');
                }}
                inputState={inputsStates.inputCiudades}
                onChangeinputValue={(value) => onChangeinputValue(value, 'inputCiudades')}
              />
            </div>
            ) : null }
            
              
            { (Number(form.estado_global) === 0) ? (
              <div>
                <MultiSelect
                  originalArr={establecimientos.map((establecimiento) => ({
                    label: `${establecimiento.nombre_establecimiento} (${establecimiento.ciudad})`,
                    value: establecimiento.nombre_establecimiento,
                    value2: establecimiento.ciudad,
                    value3: establecimiento.id,
                  }))}
                  limitTags={4}
                  items={filteredEstablecimientos.map((establecimiento) => ({
                    label: `${establecimiento.nombre_establecimiento} (${establecimiento.ciudad})`,
                    value: establecimiento.nombre_establecimiento,
                    value2: establecimiento.ciudad,
                    value3: establecimiento.id,
                  }))}
                  label="Establecimientos"
                  placeholder="Establecimientos"
                  selectAllLabel="Todos"
                  initialValue={controls.establecimientosControl}
                  onChange={(e) => {
                    onChangeInputs(e, 'campanasEstablecimientos');
                  }}
                  inputState={inputsStates.inputEstablecimientos}
                  onChangeinputValue={(value) => onChangeinputValue(value, 'inputEstablecimientos')}
                />
              </div>
            ) : null }

            { (Number(form.estado_global) === 0) ? (
              <div>
                <MultiSelect
                  originalArr={vehiculos.map((vehiculo) => ({
                    label: vehiculo.linea,
                    value: vehiculo.id,
                  }))}
                  limitTags={4}
                  items={filteredVehiculos.map((vehiculo) => ({
                    label: vehiculo.linea,
                    value: vehiculo.id,
                  }))}
                  label="Vehículos"
                  placeholder="Vehículos"
                  selectAllLabel="Todos"
                  initialValue={controls.vehiculosControl}
                  onChange={(e) => {
                    onChangeInputs(e, 'campanasVehiculos');
                  }}
                  inputState={inputsStates.inputVehiculos}
                  onChangeinputValue={(value) => onChangeinputValue(value, 'inputVehiculos')}
                />
              </div>
            ) : null }

          { (Number(form.estado_global) === 0) ? (
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justifyContent="flex-start">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-inline"
                    label="Fecha Inicial"
                    value={form.fechaInicial || ''}
                    defaultValue={selectedDateInit}
                    onChange={(e) => {
                      onChangeInputs(e, 'fechaInicial');
                    }}
                    onChangeinputValue={(value) => onChangeinputValue(value, 'inputFechaInicial')}
                    initialValue={controls.fechaInicialControl}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-inline"
                    label="Fecha Final"
                    value={form.fechaFinal || ''}
                    defaultValue={selectedDateEnd}
                    onChange={(e) => {
                      onChangeInputs(e, 'fechaFinal');
                    }}
                    initialValue={controls.fechaFinalControl}
                    onChangeinputValue={(value) => onChangeinputValue(value, 'inputFechaFinal')}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </div>
          ) : null }

            <DialogActions>
              {loading ? (
                <CircularProgress />
              ) : (
                <Button disabled={disabled} type="submit" color="warning">
                  Guardar
                </Button>
              )}
              <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CampanasAdd;
